module.exports = __webpack_public_path__ + "img/habilidades-directivas.7295e2d1.jpg";